export default class ImportResultRowVariant {
  get(row) {
    if (row.status === 'ERROR') {
      return 'error'
    }
    return ''
  }
}
